import { render, staticRenderFns } from "./guardianship.vue?vue&type=template&id=14ab3476&scoped=true&"
import script from "./guardianship.vue?vue&type=script&lang=js&"
export * from "./guardianship.vue?vue&type=script&lang=js&"
import style0 from "./guardianship.vue?vue&type=style&index=0&id=14ab3476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ab3476",
  null
  
)

export default component.exports